import { ACTIVE_MODEL, ASSET_STATES, DISPOSAL_TYPES } from "../constants";

export const getAttributeValue = (attributes, name) => {
  if (Array.isArray(attributes)) {
    const attribute = attributes.find(attr => attr.name === name);
    return attribute?.data?.value || null;
  } else if (typeof attributes === 'object' && attributes !== null) {
    return attributes[name] || null;
  } else {
    console.warn("attributes no es un arreglo ni un objeto:", attributes);
    return null;
  }
};

export const vacaPnState = (t, attributes, showReason = true) => {
  const disposalType = getAttributeValue(attributes, "disposal_type")
  ?.toUpperCase()
  const quarantineStartDate = getAttributeValue(attributes, "quarantine_start_date");
  const quarantineEndDate = getAttributeValue(attributes, "quarantine_end_date");
  const today = new Date();

  if (disposalType === DISPOSAL_TYPES.FAENA) return [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.FAENADO}`), ASSET_STATES.FAENADO];

  if (disposalType) {
    return showReason
      ? [`${t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.DADO_DE_BAJA}`)} - ${t(`disposal.Motivo`)}: ${t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${disposalType}`)}`, ASSET_STATES.DADO_DE_BAJA]
      :  [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${disposalType}`), disposalType];
  }

  if (quarantineStartDate && quarantineEndDate) {
    const startDate = new Date(quarantineStartDate);
    const endDate = new Date(quarantineEndDate);
    return today >= startDate && today <= endDate ?
      [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.CUARENTENA}`), ASSET_STATES.CUARENTENA]
      : 
      [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.PRODUCTIVO}`), ASSET_STATES.PRODUCTIVO]
  }

  if (quarantineStartDate && !quarantineEndDate) return [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.CUARENTENA}`), ASSET_STATES.CUARENTENA];

  return [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.PRODUCTIVO}`), ASSET_STATES.PRODUCTIVO];
};

export const vacaArState = (t, attributes, showReason = true) => {
  const disposalType = getAttributeValue(attributes, "disposal_type")
    ?.toUpperCase()

  if (disposalType === DISPOSAL_TYPES.FAENA) return [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.FAENADO}`), ASSET_STATES.FAENADO];

  if (disposalType) {
    return showReason
      ? [`${t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.DADO_DE_BAJA}`)} - ${t(`disposal.Motivo`)}: ${t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${disposalType}`)}`, ASSET_STATES.DADO_DE_BAJA]
      :  [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${disposalType}`), disposalType];
  }

  return [t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.PRODUCTIVO}`), ASSET_STATES.PRODUCTIVO];
};

export const MtRState = (t, attributes, showReason = true) => {
  const assetStatus  = getAttributeValue(attributes, "asset_status_change")
  let status = null

  switch (assetStatus) {
    case t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.active`):
      status = ASSET_STATES.active
      break;
    case t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.expired`):
      status = ASSET_STATES.expired
      break;
    case t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.inactive`):
      status = ASSET_STATES.inactive
      break;
    case t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.invalidated`):
      status = ASSET_STATES.invalidated
      break;
      case t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.observed`):
      status = ASSET_STATES.observed
      break;
    case t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.validated`):
      status = ASSET_STATES.validated
      break;
    default:
      status = ASSET_STATES.expired;
  }

  return [assetStatus, status]
}

export const MaltBeState = (t, attributes, showReason = true) => {
  const assetStatus  = getAttributeValue(attributes, "blending_state")
  let status = null

  switch (assetStatus) {
    case t(`basicFormStepByStep.fieldTranslate.select.blending_state.noBlending`):
      status = ASSET_STATES.noBlending
      break;
    case t(`basicFormStepByStep.fieldTranslate.select.blending_state.blending`):
      status = ASSET_STATES.blending
      break;
    default:
      status = ASSET_STATES.noBlending;
  }

  return [assetStatus, status]
}

export const stateRules = {
  [ACTIVE_MODEL.vacaPn]: vacaPnState,
  [ACTIVE_MODEL.vacaAr]: vacaArState,
  [ACTIVE_MODEL.MtR]: MtRState,
  [ACTIVE_MODEL.MaltBE]: MaltBeState,
};